// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"24":"50f90089","60":"a7d27d78"}[chunkId] + ".chunk.css";
};